import  { Component } from '@angular/core';
import { AlertController} from 'ionic-angular';
import { SharedComponent } from '../../shared/shared';
import { CommonService } from './../../services/common.service';



@Component({
  templateUrl:'contact-us.html'
})

export class ContactUsComponent  {
	
	

	/*ForgotBtnClick(event){
		alert();
		this.navCtl.push(HelloIonicPage);

	}*/

  $onInit = () => { };
  registerCredentials = { email: '',name:'', description: '',subject:'',userId:111222 };

  constructor(private alertCtrl: AlertController,public sharedClass:SharedComponent, private commonService:CommonService) { }


  public submitDetail() {

    this.commonService.showLoading();

    let requestData=this.registerCredentials;
    requestData.subject=this.registerCredentials.subject+'#'+this.registerCredentials.email;

     this.commonService.sendMailToSupport(requestData).subscribe(success => {

       this.commonService.dismisshowoading();
       if (success && success.status=="success") { 
         this.registerCredentials = { email: '', name:'', description: '',subject:'',userId:111222 };
         this.commonService.showPopup("Success", "Your query sent successfully. You will get response to this query on your email.");
       } else {
         this.commonService.showPopup("Sorry", this.sharedClass.messages.ServerError);
       }
     });  
  }

  
  showError(text) {
    this.commonService.dismisshowoading();

    let alert = this.alertCtrl.create({
      title: 'Fail',
      subTitle: text,
      buttons: ['OK']
    });
    //alert.present(promt)
    alert.present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/login/contact-us.ts